import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 59 59",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 59 59\" id=\"icon-play\"><g transform=\"translate(1 1)\" fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#FFF\" stroke-width=\"2\" cx=\"28.5\" cy=\"28.5\" r=\"28.5\" /><path fill=\"#FFF\" d=\"m41.5 28-18 11.5v-23z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol